import { t } from "i18next";

import type { ColumnsClarFactory } from "@/core/components/shared/data-table";
import { NoTranslate } from "@/core/components/ui/no-translate";
import type { FxRateDto } from "@/features/ledger/api/dto";

/**
 * Ligne de la liste des taux de change — le DTO FxRate n'a pas
 * d'identifiant : on synthétise un `id` (couple + horodatage) car
 * `DataTableClar` l'exige.
 */
export type FxRateRow = FxRateDto & { id: string };

/** Synthétise l'identifiant de ligne d'un taux de change. */
export const fxRateRowId = (rate: FxRateDto): string =>
  `${rate.currencyFrom}-${rate.currencyTo}-${rate.effectiveAt ?? ""}-${rate.source}`;

/**
 * Colonnes de l'historique des taux de change (`POST /FxRates/all`).
 * Filtres : `currencyFrom`, `currencyTo` (texte).
 */
export const fxRatesColumns: ColumnsClarFactory<FxRateRow> = () => [
  {
    id: "currencyFrom",
    accessorKey: "currencyFrom",
    header: t("ledger.fxRates.columns.currencyFrom"),
    cell: ({ getValue }) => (
      <NoTranslate as="span" className="font-mono">
        {(getValue() as string) || "—"}
      </NoTranslate>
    ),
    meta: { type: "text" },
  },
  {
    id: "currencyTo",
    accessorKey: "currencyTo",
    header: t("ledger.fxRates.columns.currencyTo"),
    cell: ({ getValue }) => (
      <NoTranslate as="span" className="font-mono">
        {(getValue() as string) || "—"}
      </NoTranslate>
    ),
    meta: { type: "text" },
  },
  {
    id: "rate",
    accessorKey: "rate",
    header: t("ledger.fxRates.columns.rate"),
    cell: ({ getValue }) => (
      <NoTranslate as="span" className="font-mono">
        {String(getValue() ?? "—")}
      </NoTranslate>
    ),
    meta: { type: "denied" },
  },
  {
    id: "effectiveAt",
    accessorKey: "effectiveAt",
    header: t("ledger.fxRates.columns.effectiveAt"),
    cell: ({ getValue }) => (
      <NoTranslate as="span" className="text-xs">
        {(getValue() as string) || "—"}
      </NoTranslate>
    ),
    meta: { type: "denied" },
  },
  {
    id: "source",
    accessorKey: "source",
    header: t("ledger.fxRates.columns.source"),
    cell: ({ getValue }) => (
      <NoTranslate as="span">{(getValue() as string) || "—"}</NoTranslate>
    ),
    meta: { type: "denied" },
  },
];
